import React from 'react';
import TariffLtls from './tariffTabs/tariffLtls';
import TariffAdditionalCosts from './tariffTabs/tariffAdditionalCosts';
import CardLayout from '../../../components/CardLayout';
import Content from '../customDictionary/cardContent';
import History from '../../customGrid/components/shared/history';
import Documents from '../../customGrid/components/shared/documents';


const TariffTabs = ({
    props,
    form,
    columns,
    name,
    id,
    error,
    title,
    canEdit,
    useDocuments,
    useHistory,
    onClose,
    onChangeForm,
    actionsFooter,
    actionsHeader,
    openModal,
    onOpenModal,
    loading

}) => {

    const getPanes = () => {
        let baseColumns = columns.filter(column => !column.groupKey);

        let obj = [
            {
                menuItem: 'general info',
                render: () => (
                    <Content
                        columns={baseColumns}
                        error={error}
                        form={form}
                        canEdit={canEdit}
                        handleChange={onChangeForm}
                    />
                ),
            },
        ];

        let groups = Array.from(new Set(columns.filter(column => column.groupKey).map((column) => column.groupKey)));
        groups.forEach(groupKey => {
            let groupColumns = columns.filter(column => column.groupKey === groupKey);
            obj.push({
                menuItem: groupKey,
                render: () => (
                    <Content 
                        columns={groupColumns} 
                        error={error} 
                        form={form} 
                        canEdit={canEdit}
                        handleChange={onChangeForm}
                    />
                ),
            });
        });
        
        obj.push({
            menuItem: 'tariffLtls',
            render: () => (
                <TariffLtls
                    form={form}
                    onChange={onChangeForm}
                    gridName={name}
                    load={loading}
                    error={error}
                />
            ),
        });
        obj.push({
            menuItem: 'tariffAdditionalCosts',
            render: () => (
                <TariffAdditionalCosts
                    form={form}
                    onChange={onChangeForm}
                    gridName={name}
                    formColumns={columns}
                    load={loading}
                    error={error}
                />
            ),
        });

        if (useDocuments) {
            obj.push({
                menuItem: 'documents',
                render: () => (
                    <Documents
                        gridName={name}
                        cardId={id}
                        isEditPermissions={canEdit}
                        canAddDocuments={!form?.cannotAddDocuments}
                    />
                ),
            });
        }

        if (useHistory) {
            obj.push({
                menuItem: 'history',
                render: () => <History cardId={id} />,
            });
        }

        return obj;
    };

    return (
        <CardLayout
            title={title}
            actionsFooter={actionsFooter}
            actionsHeader={actionsHeader}
            content={getPanes}
            onClose={onClose}
            loading={loading}
        />

    );
};

export default TariffTabs;
